import { memo } from 'react';

import { type SearchBoardsResponse } from '@air/api/types';
import { useCommandState } from '@air/cmdk';

import { SearchCommandBoardListItem } from '~/components/SearchCommand/SearchCommandBoardListItem';
import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type SearchCommandBoardListProps = {
  boards: SearchBoardsResponse[];
  onBoardClick: (board: SearchBoardsResponse) => void;
};

export const SearchCommandBoardList = memo(({ boards, onBoardClick }: SearchCommandBoardListProps) => {
  const search = useCommandState((state) => state.search);
  const { ui2026 } = useTemporaryFeatureFlags();
  const showJumpToHeading = ui2026 || Boolean(search);
  const groupHeading = showJumpToHeading ? 'Jump to' : 'Recent boards';

  return (
    <SearchCommandGroup heading={groupHeading}>
      {boards.map((board) => (
        <SearchCommandBoardListItem board={board} key={board.id} onSelect={onBoardClick} />
      ))}
    </SearchCommandGroup>
  );
});

SearchCommandBoardList.displayName = 'SearchCommandBoardList';
